import React, { Component } from "react";

class CollapseHeader extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { className, children, onClick, ...props } = this.props;
		const style = ["collapse-header-component", !!className ? className : ""].join(" ");

		return (
			<div className={style} {...props} onClick={e => onClick(e)}>
				{children}
			</div>
		);
	}
}

export default CollapseHeader;
